import { Module } from "vuex";
import { State } from "../store";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/plugins/firebase";
import { Memo } from "@/common/types/Memo";
import { PLAY_STYLE } from "@/common/types/PlayStyle";
import Chart from "@/models/Chart";

export type MemoState = {
  memo: Memo[] | null;
};

const memoModule: Module<MemoState, State> = {
  namespaced: true,
  state: {
    memo: null,
  },
  mutations: {
    setMemoArray(state, memoArray) {
      state.memo = memoArray;
    },
    setMemo(state, memo: Memo) {
      if (state.memo === null) {
        return;
      }

      state.memo = state.memo.filter(
        (e) =>
          !(
            e.musicId === memo.musicId &&
            e.revision === memo.revision &&
            e.playStyle === memo.playStyle &&
            e.difficulty === memo.difficulty
          )
      );

      state.memo.push(memo);
    },
  },
  actions: {
    async getMemoArray({ state, commit }) {
      if (state.memo !== null) {
        return state.memo;
      }
      const fn = httpsCallable(functions, "memo-get");
      const result = ((await fn()) as { data: Memo[] }).data;

      commit("setMemoArray", result);
      return result;
    },
    async getMemo({ dispatch }, chart: Chart) {
      const memoArray: Memo[] = await dispatch("getMemoArray");
      return (
        memoArray.find(
          (e: Memo) =>
            e.musicId === chart.music.id &&
            e.revision === chart.music.revision &&
            e.playStyle === chart.playStyle &&
            e.difficulty === chart.difficulty
        ) ?? {
          musicId: chart.music.id,
          revision: chart.music.revision,
          playStyle: chart.playStyle,
          difficulty: chart.difficulty,
          memo: "",
          option:
            chart.playStyle === PLAY_STYLE.SP
              ? {
                  option1: null,
                }
              : {
                  option1: null,
                  option2: null,
                  flip: null,
                },
        }
      );
    },
    async setMemo({ commit, dispatch }, memo: Memo) {
      const fn = httpsCallable(functions, "memo-set");
      const result = await fn(memo);

      await dispatch("getMemoArray");
      commit("setMemo", result.data);
      return result.data;
    },
  },
};

export default memoModule;
